export const orderMenuRouter = [{
  // has: 'orderList',
  path: 'repair/order-govern/list',
  icon: ' iconfont iconrepair',
  name: 'orderGovern',
  title: '尾气治理接车',
  component: () => import('@/views/gip/repair/order-govern.vue')
}, {
  // has: 'orderList',
  path: 'repair/order-maintenance/list',
  icon: ' iconfont iconbao',
  name: 'orderMaintenance',
  title: '普通维保接车',
  component: () => import('@/views/gip/repair/order-maintenance.vue')
}]

export const orderOtherRouter = [
  {
    // has: 'orderUpdate',
    path: 'repair/order/edit',
    icon: 'social-buffer',
    name: 'orderEdit',
    title: '编辑工单',
    // meta: {activeName: 'orderList'},
    component: () => import('@/views/gip/repair/order-edit.vue')
  }, {
    // has: 'orderDetail',
    path: 'repair/order/detail',
    icon: 'social-buffer',
    name: 'orderDetail',
    title: '工单详情',
    // meta: {activeName: 'orderList'},
    component: () => import('@/views/gip/repair/order-detail.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/repair/order.js